import * as React from 'react';

import { observer } from 'mobx-react';
import { createNumberMask } from 'text-mask-addons/dist/textMaskAddons';
import {
    decimalMaskOptions,
    integerMaskOptions,
    FieldText, usDateFormatOptions
} from '@components/field-builder/field-text';
import { FieldRadio } from '@components/field-builder/field-radio';
import { FieldCheckBox } from '@components/field-builder/field-checkbox';
import { FieldSelect } from '@components/field-builder/field-select';
import { SectionBlock } from '@components/field-builder/styles';
import {
    Field
} from '@models/field-builder/field';
import { FieldType } from '@models/field-builder/field-type';

export interface IProps {
    fields: Field[];
}

const FieldBuilder = ({ fields }: IProps) => {
    const getFieldByType = (field: Field) => {
        if (field.hidden) {
            return;
        }
        switch (field.type) {
            default:
            case FieldType.TEXT:
                return <FieldText key={field.id}
                                  {...field} />;
            case FieldType.DATE:
                return <FieldText key={field.id}
                                  {...field}
                                  maskOptions={field?.maskOptions || usDateFormatOptions} />;
            case FieldType.INTEGER:
                return <FieldText key={field.id}
                                  {...field}
                                  maskOptions={field?.maskOptions || { mask: createNumberMask(integerMaskOptions) }} />;
            case FieldType.DECIMAL:
                return <FieldText key={field.id}
                                  {...field}
                                  maskOptions={field?.maskOptions || { mask: createNumberMask(decimalMaskOptions) }} />;
            case FieldType.RADIO:
                return <FieldRadio key={field.id} {...field} />;
            case FieldType.SELECT:
                return <FieldSelect key={field.id} {...field} />;
            case FieldType.CHECKBOX:
                return <FieldCheckBox key={field.id} {...field} />;
        }
    };

    return (
        <SectionBlock>
            {
                fields?.map(fieldData => getFieldByType(fieldData))
            }
        </SectionBlock>
    );
};

export default observer(FieldBuilder);



// WEBPACK FOOTER //
// ./src/components/field-builder/index.tsx